import React, { Component } from "react";
import cn from "classnames";
import { FormattedMessage } from "react-intl";

import { isMobile, aspectRatio as ar } from "../../../../../common/parameters";

import Icon from "../../../../icon";

import Score from "../../../Score/score-display";

import Wrapper from "../../Wrapper";

import getBirdsPath from "../Common/getBirdsPath";
import MessageDisplay from "../Common/MessageDisplay";
import NotEdited from "../Common/NotEdited";
import play, { resetPlay } from "../Common/play";
import setUp from "../Common/setupNotation";
import getScale from "../Common/getScale";

import { PlayBtn, Label, SubmitButton } from "../common-style";

import {
    ScoreWrapper,
    Asset1Wrapper,
    Asset2Wrapper,
    Asset3Wrapper,
    EasterBackground,
    ChristmasBackground,
} from "./styles";
import messages from "./messages";
import { IProps, IState } from "./interfaces";
import { INotationThis } from "../Common/interfaces";

class Barline extends Component<IProps, IState> {
    static defaultProps = {
        handlePlayCount: () => {},
        handleFailCount: () => {},
        completed: () => {},
    };
    play = play.bind(this as unknown as INotationThis);
    setUp = setUp.bind(this as unknown as INotationThis);
    distribution?: number[][];
    scoreRef?: HTMLDivElement;
    pauseOffset?: number;
    constructor(props: IProps) {
        super(props);
        this.state = {
            playing: false,
            completed: false,
            currentNote: null,
            notes: [],
            playingNote: [],
            activeVoice: 0,
            playable: false,
            solutions: [],
            incorrectBarlines: undefined,
            doPos: {
                value: 0,
                alt: 0,
            },
        };

        if (props.setReset) {
            props.setReset(this.resetTask);
        }
        if (props.saveState) {
            props.saveState(this.saveState);
        }
        if (props.restoreState) {
            props.restoreState(this.restoreState);
        }
        if (props.showSolution) {
            props.showSolution(this.showSolution);
        }
    }
    resetTask = () => {
        this.setState({
            completed: false,
            activeVoice: 0,
            incorrectBarlines: undefined,
            solutions: [],
        });
    };
    saveState = () => {
        return {
            completed: this.state.completed,
            activeVoice: this.state.activeVoice,
            solutions: [...(this.state.solutions || [])],
            incorrectBarlines: this.state.incorrectBarlines,
        };
    };
    restoreState = (state: IState) => {
        this.setState({
            completed: state.completed,
            activeVoice: state.activeVoice,
            solutions: state.solutions,
            incorrectBarlines: state.incorrectBarlines,
        });
    };
    showSolution = () => {
        this.setState({
            completed: true,
            activeVoice: 0,
            solutions: this.state.correctBarlines,
            incorrectBarlines: undefined,
        });
    };
    componentDidMount() {
        const { task } = this.props;
        if (task.data.score || task.ref) {
            this.setUp();
            setTimeout(() => {
                const { taskScore, solutions, upbeatLength } = this.state;
                if (taskScore && !!taskScore.bars[0] && solutions!.indexOf(upbeatLength! - 1) === -1) {
                    this.setState({ solutions: [...solutions!, upbeatLength! - 1] });
                }
            });
        }
    }

    componentWillUnmount() {
        window.removeEventListener("blur", this.blur);
        if (this.state.playing) {
            this.play();
        }
    }

    blur = () => {
        this.play();
    };

    setRef = (ref: HTMLDivElement) => {
        this.scoreRef = ref;
    };
    setDistribution = (distribution: number[][]) => {
        this.distribution = distribution;
    };

    selectBarline = ({ bar }: { bar: number }) => {
        const { solutions, completed } = this.state;
        if (completed) return;
        if (solutions?.includes(bar)) {
            this.setState({
                solutions: solutions.filter(solution => solution !== bar),
                incorrectBarlines: undefined,
            });
        } else {
            this.setState({
                solutions: [...solutions!, bar],
                incorrectBarlines: undefined,
            });
        }
    }

    submit = () => {
        const { correctBarlines, solutions } = this.state;
        let incorrectBarlines: number[] | undefined = [];
        solutions!.forEach(bar => {
            if (!correctBarlines!.includes(bar)) {
                incorrectBarlines!.push(bar);
            }
        });
        let completed = correctBarlines!.length === solutions!.length;
        if (completed) {
            solutions?.forEach(bar => {
                if (!correctBarlines!.includes(bar)) {
                    completed = false;
                }
            });
        }
        if (completed) {
            incorrectBarlines = undefined;
            if (this.props.completed) {
                this.props.completed("barline");
            }
        } else {
            if (this.props.handleFailCount) {
                this.props.handleFailCount();
            }
        }
        this.setState({ incorrectBarlines, completed });
    }

    render() {
        const {
            playable,
            playing,
            completed,
            activeVoice,
            playingNote,
            solutions,
            incorrectBarlines,
            taskScore,
        } = this.state;
        const { task, isLow, isDemo, plan, handleHomeworkNext, isEaster, isChristmas } = this.props;
        const { data } = task;
        if (!data || !playable)
            return (
                <div>
                    <div>
                        <Wrapper>
                            <NotEdited />
                        </Wrapper>
                    </div>
                </div>
            );
        let scale = getScale(plan, task);
        return (
            <Wrapper isDemo={isDemo}>
                {isLow && (
                    <>
                        <Asset1Wrapper>
                            <img src={getBirdsPath("/singing/asset-01.svg")} alt="decoration" />
                        </Asset1Wrapper>
                        <Asset2Wrapper>
                            <img src={getBirdsPath("/singing/asset-02.svg")} alt="decoration" />
                        </Asset2Wrapper>
                        <Asset3Wrapper>
                            <img src={getBirdsPath("/singing/asset-03.svg")} alt="decoration" />
                        </Asset3Wrapper>
                    </>
                )}
                {isEaster && (
                    <EasterBackground />
                )}
                {isChristmas && (
                    <ChristmasBackground />
                )}
                <ScoreWrapper isLow={!!isLow} isEaster={isEaster || isChristmas}>
                    <Score
                        score={taskScore!}
                        activeVoice={activeVoice}
                        playingNote={playingNote}
                        scale={scale * (isLow ? 0.5425 : (isEaster || isChristmas) ? (1076 / ar.width) : 1)}
                        whiteBackground={isLow}
                        playing={playing}
                        setRef={this.setRef}
                        setDistribution={this.setDistribution}
                        isEaster={isEaster || isChristmas}
                        changeBarline={this.selectBarline}
                        selectedBarlines={solutions}
                        incorrectBarlines={incorrectBarlines}
                        barlineTask
                    />
                </ScoreWrapper>
                <PlayBtn
                    className={cn("button", "button--play")}
                    isEaster={isEaster}
                    resetPlay={this.pauseOffset && !playing ? resetPlay.bind(this as unknown as INotationThis) : undefined}
                    onClick={() => {
                        if (isMobile) return;
                        this.play(false);
                    }}
                    onTouchStart={() => {
                        if (isMobile) this.play(false);
                    }}
                    isLow={isLow}
                >
                    {playing ? <Icon i="pause" /> : <Icon i="play" />}
                    <Label>
                        <FormattedMessage {...messages.play} />
                    </Label>
                </PlayBtn>

                {!completed && !incorrectBarlines && (
                    <SubmitButton
                        isEaster={isEaster}
                        isLow={isLow}
                        style={{ top: isLow ? 30 : 6, bottom: "auto" }}
                        className={cn("button")}
                        onClick={this.submit}
                    >
                        <FormattedMessage {...messages.submit} />
                    </SubmitButton>
                )}
                {completed && <MessageDisplay isChristmas={isChristmas} isLow={!!isLow} type="completed" handleHomeworkNext={handleHomeworkNext} />}
                {!!incorrectBarlines && <MessageDisplay isChristmas={isChristmas} isLow={!!isLow} type="incorrect" />}
            </Wrapper>
        );
    }
}

export default Barline;
